import c from 'classnames';
import { ReactNode } from 'react';

type ProductRowProps = {
  children: ReactNode;
  gridCols?: number;
};

export const ProductRow = ({ children, gridCols = 5 }: ProductRowProps) => {
  if (!children) return null;

  return (
    <div className="relative">
      <div
        className={c(
          '[&>article]:!min-w-[50%]',
          'grid grid-cols-2 gap-4 lg:gap-5 lg:gap-y-2',
          'md:grid-cols-4',
          gridCols === 5 ? 'lg:grid-cols-5' : 'lg:grid-cols-4'
        )}
      >
        {children}
      </div>
    </div>
  );
};
